import { unwrapResult } from '@reduxjs/toolkit';
import Loading from 'components/Loading';
import { INIT_PAGINATION } from 'constants/common.constant';
import { getUniqueKey } from 'helpers/common.helper';
import { IQueryParam } from 'interfaces/common.interface';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Card, CardBody, Col, Row, Table } from 'reactstrap';
import { getReport } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';

const Report = () => {
  const dispatch = useAppDispatch();

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [params, setParams] = useState<IQueryParam>({
    page: INIT_PAGINATION.PAGE,
    limit: INIT_PAGINATION.LIMIT,
  });
  const [pagination, setPagination] = useState<any>(null);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res: any = await unwrapResult(await dispatch(getReport(params)));

      if (res && res.items && res.pagination) {
        setData([...data, ...res.items]);
        setPagination(res.pagination);
      } else {
        setData([...[]]);
        setPagination(null);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchMoreData = () => {
    if (params.page && params.page < pagination.totalPages) {
      setParams({ ...params, page: params.page + 1 });
    }
  };

  const resetData = () => {
    setData([...[]]);
    setPagination(null);
  };

  useEffect(() => {
    if (params) {
      fetchData();
    }
  }, [params]);

  useEffect(() => {
    if (pagination) {
      if (pagination.currentPage < pagination.totalPages) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    }
  }, [pagination]);

  return (
    <>
      <div className="content report-content">
        <Row>
          <Col md="12">
            {data && data.length ? (
              <Card>
                <CardBody>
                  <InfiniteScroll
                    dataLength={data.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={null}
                    endMessage={
                      <p className="all-items-txt">You have seen all items</p>
                    }
                  >
                    <Table responsive>
                      <thead className="text-primary">
                        <tr>
                          <th>Reporter</th>
                          <th>Reported User</th>
                          <th>Reason</th>
                          <th>Created At</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data.map((item) => (
                          <tr key={getUniqueKey()}>
                            <td>
                              <a
                                target="_blank"
                                href={`user/${item.reporter._id}`}
                              >
                                {item.reporter.fullName}
                              </a>
                            </td>
                            <td>
                              <a
                                target="_blank"
                                href={`user/${item.reportedUser._id}`}
                              >
                                {item.reportedUser.fullName}
                              </a>
                            </td>
                            <td>{item.reason}</td>
                            <td>
                              {moment(item.createdAt).format('YYYY-MM-DD')}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </InfiniteScroll>
                </CardBody>
              </Card>
            ) : (
              <p className="all-items-txt">No items.</p>
            )}

            {loading && <Loading />}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Report;
